import type { CompleteOnboardingResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createMutation } from '~/shared/api'

import { mapUserFromApi } from './mappers/mapUserFromApi'
import { UserQuery } from './UserQuery'

/**
 * POST /users/me/onboarding — отметить регистрацию завершённой.
 *
 * Тела нет: дату ставит сервер. Ручка идемпотентна (повторный вызов не сдвигает дату),
 * поэтому ретрай при плохой сети безопасен.
 */
export const CompleteOnboardingMutation = createMutation<
  void,
  CompleteOnboardingResponse,
  ReturnType<typeof mapUserFromApi>
>({
  key: 'user.completeOnboarding',
  path: API_PATHS.user.onboarding,
  method: 'POST',
  transform: mapUserFromApi,
  idempotency: true,
  sideEffects: {
    // Ответ — тот же профиль, что отдаёт `GET /users/me`, поэтому кладём его в кэш профиля
    // напрямую, вместо инвалидации. Так сессия узнаёт о пройденном онбординге из ответа самой
    // отметки, а не лишним запросом ровно в тот момент, когда открывается главная.
    onSuccess: (user, { queryClient }) => {
      queryClient.setQueryData(UserQuery.getQueryKey(), user)
    },
  },
})
